import React, { useRef } from 'react';

const DEFAULT_LABEL_HEIGHT = 20;

const TimelineHightlightExtremes = ({ extremes, colour, height, index, margins, xScale, yScale, isMin }) => {
    const fontSizeDataLabels = '.7em';
    return extremes.map((datum, index2) => {
        const xpos = xScale(datum.x);
        const ypos = yScale(datum.y);

        const labelHeight = isMin ? 15 : 0;

        const dataLabelTextPosY = height + margins.top + index * DEFAULT_LABEL_HEIGHT + 5; // Emperical test for 15

        return (
            <g key={`${height}_${margins.top}_${index}_${index2}`}>
                {ypos + margins.top + labelHeight <= height + margins.top - 15 ? (
                    <line
                        x1={xpos}
                        x2={xpos}
                        y1={ypos + margins.top + labelHeight}
                        y2={height + margins.top - 15}
                        stroke={colour}
                        strokeWidth='1'
                        strokeLinecap='butt'
                        strokeDasharray='8'
                    />
                ) : (
                    <></>
                )}
                <text dominantBaseline='top' textAnchor='middle' x={xpos} y={dataLabelTextPosY} fill={colour} style={{ fontSize: fontSizeDataLabels }}>
                    {datum.timeX}
                </text>
            </g>
        );
    });
};

const TimelineHighlights = (props) => {
    const {
        height,
        margins,
        graphDataWithHightlightedTimeline,
        scale: { xScale, yScale },
    } = props;
    const dataLabelGroup = useRef();

    const dataLabelsHighlightsLine = graphDataWithHightlightedTimeline.map((graphData, index) => {
        const maxExtremes = graphData.maximaHighlightOnTimelineEnabled ? graphData.max : [];
        const minExtremes = graphData.minimaHighlightOnTimelineEnabled ? graphData.min : [];

        return (
            <React.Fragment key={index}>
                <TimelineHightlightExtremes
                    {...props}
                    extremes={minExtremes}
                    colour={graphData.minimaColour}
                    index={index}
                    xScale={xScale}
                    yScale={yScale}
                    isMin={true}
                />
                <TimelineHightlightExtremes
                    {...props}
                    extremes={maxExtremes}
                    colour={graphData.maximaColour}
                    index={index}
                    xScale={xScale}
                    yScale={yScale}
                    isMin={false}
                />
            </React.Fragment>
        );
    });

    return (
        <g ref={dataLabelGroup} transform={`translate(0, 0)`}>
            {dataLabelsHighlightsLine}
        </g>
    );
};

export default TimelineHighlights;
